import { useEffect, useState } from 'react';

function getTime() {
    const d = new Date();
    const utc = d.getTime() + (d.getTimezoneOffset() * 60000);
    const nd = new Date(utc + (3600000 * -2));
    return nd.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    });
}

function Clock({ className }) {
    const [time, setTime] = useState(getTime());

    useEffect(() => {
        const interval = setInterval(() => setTime(getTime()), 1000);
        return () => clearInterval(interval);
    }, []);

    return <span className={className}>{time}</span>;
}

export { Clock };
